var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuniperTimeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.14286C4.2129 1.14286 1.14286 4.2129 1.14286 8C1.14286 11.7871 4.2129 14.8571 8 14.8571C11.7871 14.8571 14.8571 11.7871 14.8571 8C14.8571 4.2129 11.7871 1.14286 8 1.14286ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 4.57143C8.31558 4.57143 8.57142 4.82726 8.57142 5.14285V7.78843L11.3365 11.0107C11.542 11.2502 11.5145 11.611 11.275 11.8165C11.0355 12.022 10.6747 11.9945 10.4692 11.755L7.56633 8.37212C7.47743 8.26852 7.42856 8.13651 7.42856 8V5.14285C7.42856 4.82726 7.6844 4.57143 7.99999 4.57143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniperTimeOutline);
export default __webpack_public_path__ + "static/media/juniper-time-outline.6d8fa7a7b63e3241efc05343a6fa9d3b.svg";
export { ForwardRef as ReactComponent };